/** @jsxImportSource @emotion/react */
import {
  EuiFieldSearch,
  EuiFlexGroup,
  EuiFlexItem,
  EuiSuperSelect,
  EuiSuperSelectProps,
  htmlIdGenerator,
} from "@inscopix/ideas-eui";
import { useEffect, useState } from "react";

type FileBrowserFileSources = "UPLOADED" | "ANALYSIS_RESULTS" | "ALL";

export type FileBrowserFilterOptions = {
  source: FileBrowserFileSources;
};

export interface FileBrowserSearchAndFilterProps {
  selectedOptions: FileBrowserFilterOptions;
  onChangeSelectedOptions: React.Dispatch<
    React.SetStateAction<FileBrowserFilterOptions>
  >;
  query: string;
  onChangeQuery: (query: string) => void;
}
export const FileBrowserSearchAndFilter = ({
  selectedOptions,
  onChangeSelectedOptions,
  query,
  onChangeQuery,
}: FileBrowserSearchAndFilterProps) => {
  const selectFileSourceOptions: EuiSuperSelectProps<FileBrowserFileSources>["options"] =
    [
      { value: "ALL", inputDisplay: "All Files" },
      { value: "UPLOADED", inputDisplay: "Uploaded Files" },
      { value: "ANALYSIS_RESULTS", inputDisplay: "Analysis Results" },
    ];

  const [value, setValue] = useState(query);
  const fileSourceId = htmlIdGenerator("file_source_select")();

  // if the user clears the search bar by erasing all characters, reset search
  useEffect(() => {
    if (value === "" && query !== "") {
      onChangeQuery("");
    }
  }, [onChangeQuery, query, value]);

  return (
    <EuiFlexGroup justifyContent="flexStart" responsive={false}>
      <EuiFlexItem grow={true} css={{ minWidth: 200, maxWidth: 500 }}>
        <EuiFieldSearch
          compressed
          fullWidth
          placeholder="Search..."
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onSearch={(query) => onChangeQuery(query)}
          incremental={false}
        />
      </EuiFlexItem>

      <EuiFlexItem grow={false} css={{ width: 200 }}>
        <EuiSuperSelect
          id={fileSourceId}
          compressed
          aria-label="Select file sources"
          valueOfSelected={selectedOptions.source}
          onChange={(newOption) =>
            onChangeSelectedOptions((prev) => ({
              ...prev,
              source: newOption,
            }))
          }
          options={selectFileSourceOptions}
        />
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};
